<template>
  <v-container>
    <v-row>
        <v-col cols="12">
            <v-autocomplete v-model="selectedSOId" :items="sales_orders" item-text="so_number" item-value="id"
            label="Select Sales Order" clearable hide-details :loading="loading_sales"></v-autocomplete>
            <div class="mt-2" v-if="selectedSO">
                <div><b>SO: </b><router-link :to="`/sales/salesorders/${selectedSO.id}`" class="link-a" target="_blank">{{ selectedSO.so_number }}</router-link></div>
                <div><b>Név:</b> {{ selectedSO.customer_name }}</div>
                <div><b>Email:</b> {{ selectedSO.customer_email }}</div>
                <div><b>Tax number:</b> {{ selectedSO.tax_number }}</div>
                <div><b>Shipping address:</b> {{ selectedSO.shipping.postal_code }} {{ selectedSO.shipping.city }}, {{ selectedSO.shipping.address }}</div>
                <div v-if="selectedSO.items">
                    <b>Items:</b>
                    <div v-for="item in selectedSO.items" :key="item.id">
                        {{ item.qty }} db -- {{ item.reference }} - {{ item.item_name }} -- {{ item.quantity }} {{ item.unit }} -- {{ item.line_total_net }} {{ selectedSO.currency }}
                    </div>
                </div>
                <div><b>Összeg:</b> {{ selectedSO.total_gross }} {{ selectedSO.currency }}</div>
            </div>
            <v-btn @click="syncNewOrder(selectedSO)" :disabled="!selectedSO" class="mt-2">Sync</v-btn>
        </v-col>
    </v-row>
  </v-container>
</template>

<script>
//import Swal from "sweetalert2";
//import { mapGetters } from "vuex";
import ApiService from "@/core/services/api.service";
export const ENDPOINT = "sales/Orders/";

export default {
  name: "SyncFromSO",
  data() {
    return {
        sales_orders: [],
        selectedSOId: null,
        selectedSO: null,
        loading_sales: true,
    };
  },
  computed: {
    //...mapGetters(["currentUser"]),
  },
  methods: {
    /*...mapActions([
      "fetchUserGroups",
    ]),*/
    async fetchSales(){
        this.loading_sales = true;
        try{
            await ApiService.get(ENDPOINT + 'getordered')
                .then((data) => {
                    this.sales_orders = [...data.data];
                });
        }catch(e){
            console.log("STATUS:", e?.response?.status);
            console.log("DATA:", e?.response?.data);
            console.log("ERR:", e);
            this.loading_sales = false;
        }finally{
            this.loading_sales = false;
        }
    },
    syncNewOrder(sales){
        ApiService.post(ENDPOINT + 'sync', sales)
        .then((data) => {
            const syncedId = data.data.order.so_id;
            this.sales_orders = this.sales_orders.filter(o => o.sales_order_id !== syncedId);
            this.$emit('order-synced', data.data.order);
            this.resetForm();
            //console.log(data);
        });
    },
    resetForm(){
        this.selectedSO = null;
        this.selectedSOId = null;
    },
  },
  watch: {
    "selectedSOId":{
        handler(val){
            this.selectedSO = this.sales_orders.find(o => o.id === val);
        }
    },
  },
  mounted() {
    this.fetchSales();
  },
};
</script>
<style>
.link-a{
    color: rgb(0, 181, 181);
    transition: all .5s ease;
}

.link-a:hover {
    color: rgb(0, 90, 90);
    transition: .5s all ease;
}
</style>